import { api } from "../../api/api";
import { captureAxiosApiErrors } from "../../api/axios.errors";
import { ApiResponse } from "../../api/axios.types";
import { IUser } from "../../redux/UserProfileList/userProfile.types";

export interface IAuthResponse {
  token: string;
  isOTPPreview: boolean;
  user: IUser;
}

export const fetchAuthUserProfile = async (
  user_uuid: string,
): Promise<IUser> => {
  try {
    const res = await api.get<ApiResponse<IUser[]>>("/user/get-user", {
      params: {
        status: "ACTIVE",
        user_uuid,
      },
    });

    const users = res.data.data;

    if (!users || users.length === 0) {
      throw new Error("User not found");
    }

    return users[0];
  } catch (err) {
    const errorMessage = captureAxiosApiErrors(err);

    // ❌ avoid console.log in services (optional)
    // console.log("Error while get user:", errorMessage.error)

    throw new Error(errorMessage.error);
  }
};
